import { getCurrentPermissions } from '../Authentication/AuthorisationAsync';
import { AuthState } from '../Authentication/AuthorisationModels';
import { MedicationsPermissions } from '../MedicationsPermissions';

export type AllApplicationPermissions = MedicationsPermissions;

export interface Permission {
    definitionCode: AllApplicationPermissions;
    state: AuthState;
}

let permissions: Permission[];

export async function loadMedicationsPermissions() {
    const newPermissions = await getCurrentPermissions();
    setMedicationsPermissions(newPermissions);
}

export function setMedicationsPermissions(newPermissions: Permission[]) {
    permissions = newPermissions ?? [];
}

export function getMedicationsPermissions(): Permission[] {
    if (permissions) return permissions;

    throw new Error('No authorisation permissions, please make sure your application calls setApplicationPermissions');
}
